import React from 'react'
import AddProfessionalLayout from 'presentation/doctor/layouts/AddProfessional'

export default function AddProfessional() {
  return <AddProfessionalLayout />
}
